import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SpinnerGap } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { loginWithGoogle } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        // useRef (bukan useState) agar aman dari StrictMode double-invoke.
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const match = (location.hash || "").match(/session_id=([^&]+)/);
        const sessionId = match ? match[1] : "";
        const context = localStorage.getItem("google_auth_context") || "login";
        localStorage.removeItem("google_auth_context");
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }
        loginWithGoogle(sessionId, context)
            .then(() => {
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/portal", { replace: true });
            })
            .catch((err) => {
                window.history.replaceState(null, "", window.location.pathname);
                toast.error(formatApiErrorDetail(err.response?.data?.detail));
                navigate(context === "register" ? "/daftar-siswa-baru" : "/login", { replace: true });
            });
    }, [location, navigate, loginWithGoogle]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#FBF9F5]" data-testid="auth-callback">
            <div className="flex items-center gap-3 text-racing-muted text-xs uppercase tracking-[0.25em]">
                <SpinnerGap size={24} className="animate-spin text-racing-red" /> Memproses masuk dengan Google...
            </div>
        </div>
    );
}
